import { Text } from '@modusign/design-system';

import Badge from '../Badge';

interface AuthorizedResourceRoleSummaryProps {
  isActive?: boolean;
  memberCount: number;
  groupCount: number;
}

export default function AuthorizedResourceRoleSummary({
  isActive,
  groupCount,
  memberCount,
}: AuthorizedResourceRoleSummaryProps) {
  return (
    <Text fontSize="md" fontWeight="medium">
      멤버 <Badge variant={isActive ? 'emphasis' : 'basic'}>{memberCount || 0}</Badge> · 그룹{' '}
      <Badge variant={isActive ? 'emphasis' : 'basic'}>{groupCount || 0}</Badge>
    </Text>
  );
}
